import { Box, CardActionArea, CardActionAreaProps, cardActionAreaClasses } from "@mui/material";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

type InheritedProps = CardActionAreaProps & Pick<CardActionAreaProps, "component">;
interface Props extends InheritedProps {
  /** If true - children are wrapped, false - children are rendered directly. */
  enabled?: boolean;
  to?: string;
  isDisableDefaultHoverStyles?: boolean;
  children?: ReactNode;
}

export default function CardActionAreaFacade({
  enabled,
  to,
  component,
  isDisableDefaultHoverStyles,
  sx,
  children,
  ...originalProps
}: Props) {
  if (!enabled) {
    return children ? <>{children}</> : null;
  }

  return (
    <CardActionArea
      sx={{
        ...(isDisableDefaultHoverStyles && {
          [`&:hover .${cardActionAreaClasses.focusHighlight}`]: {
            opacity: 0,
          },
        }),
        ...sx,
      }}
      component={component || (to ? RouterLink : Box)}
      to={to || ""}
      {...originalProps}
    >
      {children}
    </CardActionArea>
  );
}
